import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import ReactPaginate from 'react-paginate';
import StickerItemList from '../components/collection/StickerItem';
import { ReloadSvg, NewListSvg } from '../icons/Icon';

function Items({ currentItems }) {
    return (
        <div className="filter-list">
            {currentItems &&
                currentItems.map((item) => (
                    <div>
                        <h3>{`${item.id}-${item.name}`}</h3>
                    </div>
                ))}
        </div>
    );
}

const CollectionList = forwardRef(({ 
    itemsPerPage, 
    ItemsComponent, 
    itemsActions, 
    CustomActionsComponent, 
    customActions, 
    onSelect,
    items,  }, r) => {

    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredItems, setFilteredItems] = useState(items);
    const [checked, setChecked] = useState({});

    useImperativeHandle(r, () => ({
        getChecked: () => checked,
        setChecked: (c) => setChecked(c)}));
    useEffect(() => {
        setFilteredItems(items);
        //console.log('CollectionList',items);
    }, [items]);
    useEffect(() => {
        onSelect && onSelect(checked);
    }, [checked]);
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredItems(items.filter(item => item.name.toLowerCase().includes(query)));
        setItemOffset(0);
    };
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(filteredItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(filteredItems.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, filteredItems]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % items.length;
        //console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
        setItemOffset(newOffset);
    };
    const onCheck = (e, o) => {
        const updated = { ...checked };
        if (e.target.checked) {
            updated[o.id] = true;
        } else {
            delete updated[o.id];
        }
        //console.log('onCheck', updated);
        setChecked(updated);
    }
    return (
        <div className='CollectionList'>
            <div className='CollectionList_header'>
                <div className='CollectionList_state'>
                    {`Showing ${itemOffset} to ${itemOffset + itemsPerPage} of ${items.length} Items`}
                </div>
                <div className="CollectionList_pagination">
                    <ReactPaginate
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={1}
                        marginPagesDisplayed={1}
                        pageCount={pageCount}
                        previousLabel="<"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName=""
                        activeClassName="active"
                        renderOnZeroPageCount={null}
                    />
                </div>
                <div className="CollectionList_search">
                    <input
                        type="text"
                        placeholder="Search items..."
                        value={searchQuery}
                        onChange={handleSearch}
                        className="filter-search-input"
                    />
                </div>
                {CustomActionsComponent && <CustomActionsComponent {...(customActions || {})} />}
            </div>
            {ItemsComponent && <ItemsComponent
                onCheck={onCheck}
                checked={checked}
                items={currentItems}
                {...(itemsActions || {})}
            />}
            {/**<Items currentItems={currentItems} /> */}
        </div>
    );
});

export default CollectionList;